// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--sab:env(safe-area-inset-bottom)}.input-text-icon input{padding-right:25px!important}.icon-right-flot{z-index:2;position:absolute;right:10px;top:17%}.wrap-textbox{position:relative;width:100%}.wrap-textbox input{padding-right:25px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
